// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"6963415a","171":"e21454f1","329":"6963415a","642":"6963415a","809":"6963415a"}[chunkId] + ".chunk.css";
};